import { FavoriteTabIcon } from "../../../static/icons/FavoriteTabIcon";
import { BasketTabIcon } from "../../../static/icons/BasketTabIcon";
import { MyBooksTabIcon } from "../../../static/icons/MyBooksTabIcon";
import { MainPageTabIcon } from "../../../static/icons/MainPageTabIcon";
import { CatalogTabIcon } from "../../../static/icons/CatalogTabIcon";
import { LoginTabIcon } from "../../../static/icons/LoginTabIcon";
import { BonusTabIcon } from "../../../static/icons/BonusTabIcon";
import { EMyBooksRoute } from "../../utils/enums";

export enum EThemes {
  purple = "purple",
  orange = "orange",
  default = "default",
}
export const TABS = {
  main: {
    title: "Главная",
    label: "main",
    href: "/",
    icon: MainPageTabIcon(),
  },
  catalog: {
    title: "Каталог",
    label: "catalog",
    href: "/pages/new_genres/",
    icon: CatalogTabIcon(),
  },
  bonus: {
    title: "Бонусы",
    label: "bonus",
    href: "/me/bonuses/",
    icon: BonusTabIcon(),
  },
  basket: {
    title: "Корзина",
    label: "basket",
    href: EMyBooksRoute.CART,
    icon: BasketTabIcon(),
  },
  favorite: {
    title: "Отложенные",
    label: "favorite",
    href: EMyBooksRoute.LIKED,
    icon: FavoriteTabIcon(),
  },
  myBooks: {
    title: "Мои книги",
    label: "myBooks",
    href: "/my-books/",
    icon: MyBooksTabIcon(),
  },
  login: {
    title: "Войти",
    label: "login",
    href: "/auth/login",
    icon: LoginTabIcon(),
  },
};
